<template>
    <div class="process" v-if="processType!='1'">
        <div>
            <ul class="pro_main main">
                <li class="pro_icon main" v-for="item in model.nodeList">
                    {{item.nodename}}
                    <ul class="prolc_text">
                        <template v-for="(li, index) in item.child">
                            <li @click="$emit('click',li)" :key="index" v-if="li.nodetype=='3'||li.nodetype=='5'">
                                <div 
                                :title="li.isshow==='1' ? li.nodeurl : ''" 
                                :class="{'isnew': li.isnew==='1'&&li.isshow==='1'}">
                                    {{li.nodename}}
                                </div>
                                <span class="prolc_text_icon"></span>
                            </li>
                        </template>
                    </ul>
                </li>
            </ul>
            <el-divider v-if="model.processType==='ZGYS'">
                <span class="break-text">↑资格预审流程</span>
                <span class="break-text">主要流程↓</span>
            </el-divider>
            <el-divider v-if="model.processType==='TWO'">
                <span class="break-text">↑一阶段</span>
                <span class="break-text">两阶段↓</span>
            </el-divider>
            <ul class="pro_main other">
                <li class="pro_icon other" v-for="item in model.nodeList">
                    {{item.nodename}}
                    <ul class="prolc_text">
                        <template v-for="(li, index) in item.child">
                            <li @click="$emit('click',li)" :key="index" v-if="li.nodetype=='1'||li.nodetype=='6'">
                                <div 
                                :title="li.isshow==='1' ? li.nodeurl : ''"  
                                :class="{'red': li.isclick=='css','isnew': li.isnew==='1'&&li.isshow==='1'}">
                                    {{li.nodename}}
                                </div>
                                <span class="prolc_text_icon"></span>
                            </li>
                        </template>
                    </ul>
                </li>
            </ul>
            <el-divider v-if="model.processType==='ZGYS'">
                <span class="break-text">↑主要流程</span>
                <span class="break-text">附加流程↓</span>
            </el-divider>
                <el-divider v-if="model.processType==='TWO'">
                <span class="break-text">↑两阶段</span>
                <span class="break-text">附加流程↓</span>
            </el-divider>
            <ul class="pro_main sub">
                <li class="pro_icon sub" v-for="item in model.nodeList">
                    {{item.nodename}}
                    <ul class="prolc_text">
                        <template v-for="(li, index) in item.child">
                            <li @click="$emit('click',li)" :key="index" v-if="li.nodetype=='2'">
                                <div 
                                :title="li.isshow==='1' ? li.nodeurl : ''"  
                                :class="{'red': li.isclick=='css','isnew': li.isnew==='1'&&li.isshow==='1'}">
                                    {{li.nodename}}
                                </div>
                            
                            </li>
                        </template>
                    </ul>
                </li>
            </ul>
        </div>
        
    </div>

    <!--横向流程-->
    <div class="transverse" v-else>
        
        <el-radio-group v-model="liuchengType" v-if="model.processType==='TWO'">
            <el-radio-button label="1">一阶段</el-radio-button>
            <el-radio-button label="2">两阶段</el-radio-button>
        </el-radio-group>
        <el-radio-group v-model="liuchengType" v-if="model.processType==='ZGYS'">
            <el-radio-button label="1">资格预审流程</el-radio-button>
            <el-radio-button label="2">招标阶段</el-radio-button>
        </el-radio-group>
        
        <ul class="tranMain">
            <div class="tranCon" v-for="item in model.nodeList">
                <el-row>
                    <el-col :span="3">
                        <label>{{item.nodename}}</label>
                    </el-col>
                    <el-col :span="21">
                        <ul class="prolc_text">
                            <template v-for="(li, index) in item.child">
                                <li @click="$emit('click',li)" :key="index" v-if="(li.nodetype=='3'||li.nodetype=='5')&&liuchengType=='1'" class="lcother">
                                    <div 
                                    :title="li.isshow==='1' ? li.nodeurl : ''" 
                                    :class="{'isnew': li.isnew==='1'&&li.isshow==='1'}">
                                        {{li.nodename}}
                                    </div>
                                </li>
                            </template>
                        </ul>
                        <ul class="prolc_text">
                            <template v-for="(li, index) in item.child">
                                
                                <li @click="$emit('click',li)" :key="index" v-if="(li.nodetype=='1'||li.nodetype=='6')&&liuchengType=='2'" class="lczhu">
                                    <div 
                                    :title="li.isshow==='1' ? li.nodeurl : ''"  
                                    :class="{'red': li.isclick=='css','isnew': li.isnew==='1'&&li.isshow==='1'}">
                                        {{li.nodename}}
                                    </div>
                                </li>
                                
                            </template>
                        </ul>
                        <ul class="prolc_text">
                            <template v-for="(li, index) in item.child">
                                
                                <li @click="$emit('click',li)" :key="index" v-if="li.nodetype=='2'" class="lcfu">
                                    <div 
                                    :title="li.isshow==='1' ? li.nodeurl : ''"  
                                    :class="{'red': li.isclick=='css','isnew': li.isnew==='1'&&li.isshow==='1'}">
                                        {{li.nodename}}
                                    </div>
                                
                                </li>
                            </template>
                        </ul>
                    </el-col>
                </el-row>
                
            </div>
            
        </ul>
    </div>
</template>

<script>



export default {
    props: {
        model: {
            type: Object,
            default: () => ({})
        }
    },
    data() {

        return{
            processType:window._config.processType,
            liuchengType:'1'
        }
    },
    computed: {
        id: function() {
            return this.getQuery('id') || '';
        },
    },
    watch: {
     
    },
    methods: {
        

    },
    created() {
        
    },
    mounted() {
        var that = this

    }
}
</script>

<style scoped lang="scss">

</style>
